import React from 'react';
import PropTypes from 'prop-types';
import { List } from '@pella/sash-framework';
import { classNames } from '@pella/sash-framework/dist/utilities';
import { CTA } from '../../';

const CTABanner = ({ data, className, ...other }) => {
	if (!data) return null;

	const classes = classNames({
		'ctaBanner p-5 text-center md:px-6 md:py-8 xl:px-8 xl:py-10 flex flex-col justify-center': true,
		'bg-white md:border md:border-secondary [&>div]:text-secondary': data.background === 'white',
		'bg-primary [&>div]:text-white': data.background === 'primary',
		'bg-secondary [&>div]:text-white max-xl:row-start-1': data.background === 'secondary',
	});

	return (
		<div
			className={classes}
			{...other}
		>
			{data.heading && (
				<div
					className='ctaBanner-heading text-xl font-semibold !leading-tight md:text-2xl xl:text-26px'
					dangerouslySetInnerHTML={{ __html: data.heading }}
				/>
			)}
			{data.description && (
				<div
					className='ctaBanner-desc mt-4 text-lg md:text-xl xl:mt-6 xl:text-2xl'
					dangerouslySetInnerHTML={{ __html: data.description }}
				/>
			)}
			{data.cta?.[0] && (
				<List
					bullets='none'
					className='ctaBanner-ctas mt-4 justify-center px-6 max-md:space-y-4 md:gap-x-4 xl:mt-6'
					layout='fluid'
				>
					{data.cta.map((cta, index) => (
						<li
							className='max-md:!flex-12/12 md:!flex-[0_0_272px]'
							key={index}
						>
							<CTA
								data={cta}
								size='sm'
								className='mx-auto md:max-w-[272px]'
								wide
							/>
						</li>
					))}
				</List>
			)}
		</div>
	);
};

CTABanner.propTypes = {
	data: PropTypes.object,
	className: PropTypes.string,
};

export default CTABanner;
